import { SwapProvider } from './swap-provider.interface';
import { RouteQuote } from '../routing.service';
import { environment } from '../../../environments/environment';

export class ZeroExProvider implements SwapProvider {
  private readonly network: string;
  private readonly takerAddress: string;

  constructor(network: string = 'sepolia', takerAddress: string = '', private chainId?: number) {
    this.network = network;
    this.takerAddress = takerAddress;
  }

  async getQuote(tokenInAddress: string, tokenOutAddress: string, amount: bigint, isExactOut: boolean = false, feeTiers?: number[]): Promise<RouteQuote> {
    const amtParam = isExactOut ? `buyAmount=${amount.toString()}` : `sellAmount=${amount.toString()}`;
    // Call the secure backend route to enforce admin platform fees
    let url = `${environment.apiUrl}/user/swap/quote?tokenOutAddress=${tokenOutAddress}&tokenInAddress=${tokenInAddress}&amount=${amount.toString()}&isExactOut=${isExactOut}&network=${this.network}`;
    if (this.takerAddress) {
      url += `&takerAddress=${this.takerAddress}`;
    }
    if (this.chainId) {
      url += `&chainId=${this.chainId}`;
    }

    try {
      const response = await fetch(url);
      const resData = await response.json();
      
      if (!resData.status) {
        throw new Error(resData.message || 'Aggregator routing failed');
      }
      
      const data = resData.data;

      if (data.code || data.validationErrors || (data.message && !data.data)) {
        console.error('0x API Error:', data);
        throw new Error(
          `0x Aggregator Error: ${data.reason || data.message || 'No route matched with those values'}`,
        );
      }

      if (!data.data || !data.to) {
        throw new Error(
          `0x API Error: Invalid response structure returned. Response: ${JSON.stringify(data)}`,
        );
      }

      return {
        type: 'AGGREGATOR',
        platformName: '0x API Aggregator',
        targetAddress: data.to,
        allowanceTarget: data.allowanceTarget,
        callData: data.data,
        value: data.value,
        estimatedOutput: BigInt(data.buyAmount || 0),
        estimatedInput: BigInt(data.sellAmount || 0),
        gasEstimate: data.estimatedGas,
        priceImpact: data.estimatedPriceImpact,
        permit2: data.permit2,
      };
    } catch (err: any) {
      console.error('Failed to fetch from 0x API:', err);
      throw new Error(err.message || 'Aggregator routing failed. Ensure you have an active 0x API key for testnets.');
    }
  }
}
